import { TooltipItem } from "@/components/tooltip/tooltip-types";
import xTooltipImage1 from "./tooltip-assets/twitter/x-tooltip-1.gif"
import xTooltipImage2 from "./tooltip-assets/twitter/x-tooltip-2.gif"
import xTooltipImage3 from "./tooltip-assets/twitter/x-tooltip-3.gif"
import facebookTooltipImage1 from "./tooltip-assets/facebook/facebook-tooltip-1.jpg"
import facebookTooltipImage2 from "./tooltip-assets/facebook/facebook-tooltip-2.gif"
import facebookTooltipImage3 from "./tooltip-assets/facebook/facebook-tooltip-3.gif"


export const xTwitterTooltips: TooltipItem[] = [
  { message: <p data-testid="x-privacy-tooltip">1 Dirígete a '<b>Privacidad y seguridad</b>' en la configuración de tu cuenta.</p>, illustration: <img src={xTooltipImage1} alt="" /> },
  { message: <p>2. Selecciona '<b>Audiencia y etiquetas</b>'.</p>, illustration: <img src={xTooltipImage2} alt="" /> },
  { message: <p>3. Verifica que la opción '<b>Proteger las publicaciones</b>' esté desactivada.</p>, illustration: <img src={xTooltipImage3} alt="" /> },
]

export const facebookTooltips: TooltipItem[] = [
  { message: <p data-testid="facebook-privacy-tooltip">1. Ve a la <b>publicación</b> que deseas revisar o cambiar.</p>, illustration: <img src={facebookTooltipImage1} alt="" /> },
  { message: <p>2. Haz clic en el <b>ícono de privacidad</b> debajo de tu nombre (puede ser un globo terráqueo, dos personas, etc.).</p>, illustration: <img src={facebookTooltipImage2} alt="" />},
  { message: <p>3. Verifica que la opción seleccionada sea <b>Público</b>. Si no lo es, haz clic en <b>Público</b> para cambiarlo.</p>, illustration: <img src={facebookTooltipImage3} alt="" />},
]